import { render, staticRenderFns } from "./TwoBenefit.vue?vue&type=template&id=25e100d6&scoped=true&"
import script from "./TwoBenefit.vue?vue&type=script&lang=js&"
export * from "./TwoBenefit.vue?vue&type=script&lang=js&"
import style0 from "./TwoBenefit.vue?vue&type=style&index=0&id=25e100d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e100d6",
  null
  
)

export default component.exports